var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0C0.671573 0 0 0.671573 0 1.5V13.3648C0 14.1933 0.671569 14.8648 1.5 14.8648H18.5108C19.3392 14.8648 20.0108 14.1933 20.0108 13.3648V1.5C20.0108 0.671576 19.3392 0 18.5108 0H1.5ZM2 2.4777V2H18.0108V2.4777C17.9494 2.50122 17.8894 2.53118 17.8317 2.56778L10.0054 7.53448L2.17907 2.56778C2.1214 2.53118 2.06141 2.50122 2 2.4777ZM2 4.82288V12.8648H18.0108V4.82288L10.5412 9.56318C10.2141 9.77074 9.79663 9.77074 9.46956 9.56318L2 4.82288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.32aad9e4e361b94d7eb5013d78951881.svg";
export { ForwardRef as ReactComponent };